import AreaIcon from 'assets/icons/chartIcons/area.svg?react';
import { default as AreaSplineChartIcon } from 'assets/icons/chartIcons/area_spline.svg?react';
import BarChartIcon from 'assets/icons/chartIcons/bar.svg?react';
import CloudBubbleChartIcon from 'assets/icons/chartIcons/cloud_bubble.svg?react';
import ColumnChartIcon from 'assets/icons/chartIcons/column.svg?react';
import ComboChartIcon from 'assets/icons/chartIcons/combo.svg?react';
import DonutChartIcon from 'assets/icons/chartIcons/donut.svg?react';
import DonutPieChartIcon from 'assets/icons/chartIcons/donut_pie.svg?react';
import DonutStatChartIcon from 'assets/icons/chartIcons/donut_stat.svg?react';
import FunnelChartIcon from 'assets/icons/chartIcons/funnel.svg?react';
import GroupedBarChartIcon from 'assets/icons/chartIcons/grouped_bar.svg?react';
import GroupedColumnChartIcon from 'assets/icons/chartIcons/grouped_column.svg?react';
import HalfDonutChartIcon from 'assets/icons/chartIcons/half_donut.svg?react';
import HalfDonutPieChartIcon from 'assets/icons/chartIcons/half_donut_pie.svg?react';
import HalfDonutStatChartIcon from 'assets/icons/chartIcons/half_donut_stat.svg?react';
import HalfPieChartIcon from 'assets/icons/chartIcons/half_pie.svg?react';
import HistogramChartIcon from 'assets/icons/chartIcons/histogram.svg?react';
import IconChartIcon from 'assets/icons/chartIcons/icon_chart.svg?react';
import IconStatChartIcon from 'assets/icons/chartIcons/icon_stat_chart.svg?react';
import LineChartIcon from 'assets/icons/chartIcons/line.svg?react';
import PercentageAreaChartIcon from 'assets/icons/chartIcons/percentage_area.svg?react';
import PercentageAreaSplineChartIcon from 'assets/icons/chartIcons/percentage_area_spline.svg?react';
import PercentageBarChartIcon from 'assets/icons/chartIcons/percentage_bar.svg?react';
import PercentageColumnChartIcon from 'assets/icons/chartIcons/percentage_column.svg?react';
import PieChartIcon from 'assets/icons/chartIcons/pie.svg?react';
import ProgressBarChartIcon from 'assets/icons/chartIcons/progress_bar.svg?react';
import ProgressBarStatChartIcon from 'assets/icons/chartIcons/progress_bar_stat.svg?react';
import PyramidChartIcon from 'assets/icons/chartIcons/pyramid.svg?react';
import ScatterBubbleChartIcon from 'assets/icons/chartIcons/scatter_bubble.svg?react';
import ScatterPlotChartIcon from 'assets/icons/chartIcons/scatter_plot.svg?react';
import SingleLineChartIcon from 'assets/icons/chartIcons/single_line.svg?react';
import SingleSplineChartIcon from 'assets/icons/chartIcons/single_spline.svg?react';
import SplineChartIcon from 'assets/icons/chartIcons/spline.svg?react';
import StackedAreaIcon from 'assets/icons/chartIcons/stacked_area.svg?react';
import StackedAreaSplineChartIcon from 'assets/icons/chartIcons/stacked_area_spline.svg?react';
import StackedBarChartIcon from 'assets/icons/chartIcons/stacked_bar.svg?react';
import StackedColumnChartIcon from 'assets/icons/chartIcons/stacked_column.svg?react';
import TableIcon from 'assets/icons/chartIcons/table.svg?react';
import TreeMapChartIcon from 'assets/icons/chartIcons/tree_map_chart.svg?react';
import WordCloudChartIcon from 'assets/icons/chartIcons/word_cloud_chart.svg?react';
import { UserTypes } from 'modules/User/user.types';
import {
  generateDefaultData as generateAreaChartData,
  generatePercentageAreaData,
} from 'widgets/ChartWidgets/Area/AreaChartWidget.helpers';
import {
  generateDefaultData as generateAreaSplineChartData,
  generatePercentageAreaSplineData,
  generateStackedAreaSplineDefaultData,
} from 'widgets/ChartWidgets/AreaSplineChartWidget/AreaSplineChartWidget.helpers';
import {
  generateDefaultData as generateBarChartData,
  generateDefaultMultiSeriesData as generateMultiSeriesBarChartData,
} from 'widgets/ChartWidgets/BarChartWidget/BarChartWidget.helpers';
import { generateDefaultData as generateCloudBubbleChartData } from 'widgets/ChartWidgets/CloudBubbleChartWidget/CloudBubbleChartWidget.helpers';
import {
  generateDefaultData as generateColumnChartData,
  generateDefaultMultiSeriesData as generateMultiSeriesColumnChartData,
} from 'widgets/ChartWidgets/ColumnChartWidget/ColumnChartWidget.helpers';
import { generateDefaultData as generateComboChartData } from 'widgets/ChartWidgets/ComboChartWidget/ComboChartWidget.helpers';
import { generateDefaultData as generateFunnelChartData } from 'widgets/ChartWidgets/FunnelChartWidget/FunnelChartWidget.helpers';
import {
  generateHalfDonutPieDefaultData as generateHalfDonutPieChartData,
  generateDefaultData as generateHalfPieChartData,
} from 'widgets/ChartWidgets/HalfPieChartWidget/HalfPieChartWidget.helpers';
import { generateDefaultData as generateHistogramChartData } from 'widgets/ChartWidgets/HistogramWidget/HistogramChartWidget.helpers';
import {
  generateDefaultData as generateLineChartData,
  generateSingleLineDefaultData,
} from 'widgets/ChartWidgets/LineChartWidget/LineChartWidget.helpers';
import {
  generateDonutPieDefaultData as generateDonutPieChartData,
  generateDefaultData as generatePieChartData,
} from 'widgets/ChartWidgets/PieChartWidget/PieChartWidget.helpers';
import { generateDefaultData as generatePyramidChartData } from 'widgets/ChartWidgets/PyramidChartWidget/PyramidChartWidget.helpers';
import { generateDefaultData as generateScatterBubbleChartData } from 'widgets/ChartWidgets/ScatterBubbleChartWidget/ScatterBubbleChartWidget.helpers';
import { generateDefaultData as generateScatterPlotChartData } from 'widgets/ChartWidgets/ScatterPlotChartWidget/ScatterPlotChartWidget.helpers';
import {
  generateSingleSplineDefaultData,
  generateDefaultData as generateSplineChartData,
} from 'widgets/ChartWidgets/SplineChartWidget/SplineChartWidget.helpers';
import { generateDefaultData as generateStackedAreaChartData } from 'widgets/ChartWidgets/StackedArea/StackedAreaChartWidget.helpers';
import {
  generatePercentageBarData,
  generateDefaultData as generateStackedBarChartData,
} from 'widgets/ChartWidgets/StackedBar/StackedBarChartWidget.helpers';
import {
  generatePercentageColumnData,
  generateDefaultData as generateStackedColumnChartData,
} from 'widgets/ChartWidgets/StackedColumn/StackedColumnChartWidget.helpers';
import { generateDefaultData as generateTreeMapChartData } from 'widgets/ChartWidgets/TreeMapChartWidget/TreeMapChartWidget.helpers';
import { generateDefaultData as generateWordCloudChartData } from 'widgets/ChartWidgets/WordCloud/WordCloudWidget.helpers';
import { ProgressChartType } from 'widgets/ProgressChartWidget/ProgressChartWidget.types';
import { generateDefaultData as generateStatChartData } from 'widgets/ResponsiveWidgets/StatChartWidget/StatChartWidget.helpers';
import { StatChartType } from 'widgets/ResponsiveWidgets/StatChartWidget/StatChartWidget.types';
import { generateDefaultData as generateTableData } from 'widgets/TextBasedWidgets/TableWidget/TableWidget.helpers';

export enum ChartType {
  Table = 'Table',
  Pie = 'Pie',
  DonutPie = 'DonutPie',
  Column = 'Column',
  Bar = 'Bar',
  Line = 'Line',
  SingleLine = 'SingleLine',
  StackedBar = 'StackedBar',
  StackedColumn = 'StackedColumn',
  DonutStat = 'DonutStat',
  DonutStatNoLabel = 'DonutStatNoLabel',
  HalfDonutPie = 'HalfDonutPie',
  HalfDonutStat = 'HalfDonutStat',
  HalfDonutStatNoLabel = 'HalfDonutStatNoLabel',
  HalfPie = 'HalfPie',
  ProgressBarStat = 'ProgressBarStat',
  ProgressBarStatNoLabel = 'ProgressBarStatNoLabel',
  IconStat = 'IconStat',
  IconStatNoLabel = 'IconStatNoLabel',
  Area = 'Area',
  PercentageArea = 'PercentageArea',
  StackedArea = 'StackedArea',
  WordCloud = 'WordCloud',
  Histogram = 'Histogram',
  Combo = 'ComboChart',
  GroupedColumn = 'GroupedColumn',
  GroupedBar = 'GroupedBar',
  Pyramid = 'Pyramid',
  CloudBubble = 'CloudBubble',
  ScatterPlot = 'ScatterPlot',
  AreaSpline = 'AreaSpline',
  PercentageAreaSpline = 'PercentageAreaSpline',
  StackedAreaSpline = 'StackedAreaSpline',
  Funnel = 'Funnel',
  ScatterBubble = 'ScatterBubble',
  Spline = 'Spline',
  SingleSpline = 'SingleSpline',
  PercentageBar = 'PercentageBar',
  PercentageColumn = 'PercentageColumn',
  TreeMap = 'TreeMap',
}

/**
 * Map to store the default widget data for each chart widget option
 * in the left panel.
 */
const CHART_TYPE_TO_DEFAULT_DATA_MAP = {
  [ChartType.Table]: generateTableData(),
  [ChartType.Pie]: generatePieChartData(),
  [ChartType.DonutPie]: generateDonutPieChartData(),
  [ChartType.Line]: generateLineChartData(),
  [ChartType.SingleLine]: generateSingleLineDefaultData(),
  [ChartType.SingleSpline]: generateSingleSplineDefaultData(),
  [ChartType.Column]: generateColumnChartData(),
  [ChartType.Bar]: generateBarChartData(),
  [ChartType.StackedBar]: generateStackedBarChartData(),
  [ChartType.StackedColumn]: generateStackedColumnChartData(),
  [ChartType.Area]: generateAreaChartData(),
  [ChartType.PercentageArea]: generatePercentageAreaData(),
  [ChartType.PercentageAreaSpline]: generatePercentageAreaSplineData(),
  [ChartType.PercentageBar]: generatePercentageBarData(),
  [ChartType.PercentageColumn]: generatePercentageColumnData(),
  [ChartType.StackedArea]: generateStackedAreaChartData(),
  [ChartType.WordCloud]: generateWordCloudChartData(),
  [ChartType.Histogram]: generateHistogramChartData(),
  [ChartType.HalfDonutPie]: generateHalfDonutPieChartData(),
  [ChartType.HalfPie]: generateHalfPieChartData(),
  [ChartType.Combo]: generateComboChartData(),
  [ChartType.GroupedColumn]: generateMultiSeriesColumnChartData(),
  [ChartType.GroupedBar]: generateMultiSeriesBarChartData(),
  [ChartType.Funnel]: generateFunnelChartData(),
  [ChartType.Pyramid]: generatePyramidChartData(),
  [ChartType.ScatterPlot]: generateScatterPlotChartData(),
  [ChartType.Spline]: generateSplineChartData(),
  [ChartType.CloudBubble]: generateCloudBubbleChartData(),
  [ChartType.ScatterBubble]: generateScatterBubbleChartData(),
  [ChartType.AreaSpline]: generateAreaSplineChartData(),
  [ChartType.StackedAreaSpline]: generateStackedAreaSplineDefaultData(),
  [ChartType.TreeMap]: generateTreeMapChartData(),

  // Stat charts
  [ChartType.DonutStat]: generateStatChartData(StatChartType.Donut),
  [ChartType.HalfDonutStat]: generateStatChartData(StatChartType.HalfDonut),
  [ChartType.HalfDonutStatNoLabel]: generateStatChartData(StatChartType.HalfDonut, {
    showLabel: false,
    type: ProgressChartType.HalfDonut,
  }),
  [ChartType.ProgressBarStat]: generateStatChartData(StatChartType.ProgressBar),
  [ChartType.IconStat]: generateStatChartData(StatChartType.Icon),
  [ChartType.IconStatNoLabel]: generateStatChartData(StatChartType.Icon, {
    showLabel: false,
  }),
  [ChartType.DonutStatNoLabel]: generateStatChartData(StatChartType.Donut, {
    showLabel: false,
    type: ProgressChartType.Donut,
  }),
  [ChartType.ProgressBarStatNoLabel]: generateStatChartData(StatChartType.ProgressBar, {
    showLabel: false,
    type: ProgressChartType.Bar,
  }),
};

/**
 * Chart widget data to be displayed in left menu.
 * Organized by category, each category has an array `chartWidgets` with
 * data related to the widgets for that category.
 * Default data for the widgets is stored in the CHART_NAME_TO_DEFAULT_DATA_MAP.
 */
const CHART_MENU_DATA = [
  {
    category: 'Table',
    chartWidgets: [
      {
        type: ChartType.Table,
        icon: TableIcon,
        name: 'Table',
      },
    ],
  },
  {
    category: 'Pie',
    chartWidgets: [
      {
        type: ChartType.Pie,
        icon: PieChartIcon,
        name: 'Pie',
      },
      {
        type: ChartType.DonutPie,
        icon: DonutPieChartIcon,
        name: 'Donut Pie',
      },
      {
        type: ChartType.HalfPie,
        icon: HalfPieChartIcon,
        name: 'Half-pie',
      },
      {
        type: ChartType.HalfDonutPie,
        icon: HalfDonutPieChartIcon,
        name: 'Half-donut',
      },
    ],
  },
  {
    category: 'ColumnAndBar',
    chartWidgets: [
      {
        type: ChartType.Column,
        icon: ColumnChartIcon,
        name: 'Column',
      },
      {
        type: ChartType.Bar,
        icon: BarChartIcon,
        name: 'Bar',
      },
      {
        type: ChartType.GroupedColumn,
        icon: GroupedColumnChartIcon,
        name: 'Grouped Column',
      },
      {
        type: ChartType.GroupedBar,
        icon: GroupedBarChartIcon,
        name: 'Grouped Bar',
      },
      {
        type: ChartType.StackedColumn,
        icon: StackedColumnChartIcon,
        name: 'Stacked Column',
      },
      {
        type: ChartType.StackedBar,
        icon: StackedBarChartIcon,
        name: 'Stacked Bar',
      },
      {
        type: ChartType.PercentageColumn,
        icon: PercentageColumnChartIcon,
        name: 'PercentageColumn',
        publishDate: new Date('2025-03-06'),
      },
      {
        type: ChartType.PercentageBar,
        icon: PercentageBarChartIcon,
        name: 'PercentageBar',
        publishDate: new Date('2025-03-06'),
      },
      {
        type: ChartType.Combo,
        icon: ComboChartIcon,
        name: 'Combination',
      },
      {
        type: ChartType.Histogram,
        icon: HistogramChartIcon,
        name: 'Histogram',
      },
    ],
  },
  {
    category: 'LinesAndArea',
    chartWidgets: [
      {
        type: ChartType.SingleLine,
        icon: SingleLineChartIcon,
        name: 'SingleLine',
        publishDate: new Date('2025-02-18'),
      },
      {
        type: ChartType.SingleSpline,
        icon: SingleSplineChartIcon,
        name: 'SingleSpline',
        publishDate: new Date('2025-02-28'),
      },
      {
        type: ChartType.Line,
        icon: LineChartIcon,
        name: 'Lines',
      },
      {
        type: ChartType.Spline,
        icon: SplineChartIcon,
        name: 'Splines',
        publishDate: new Date('2025-02-28'),
      },
      {
        type: ChartType.Area,
        icon: AreaIcon,
        name: 'Area',
      },
      {
        type: ChartType.StackedArea,
        icon: StackedAreaIcon,
        name: 'Stacked Area',
      },
      {
        type: ChartType.AreaSpline,
        icon: AreaSplineChartIcon,
        name: 'AreaSpline',
        publishDate: new Date('2025-02-25'),
      },
      {
        type: ChartType.StackedAreaSpline,
        icon: StackedAreaSplineChartIcon,
        name: 'StackedAreaSpline',
        publishDate: new Date('2025-02-25'),
      },
      {
        type: ChartType.PercentageArea,
        icon: PercentageAreaChartIcon,
        name: 'PercentageArea',
        publishDate: new Date('2025-02-25'),
      },
      {
        type: ChartType.PercentageAreaSpline,
        icon: PercentageAreaSplineChartIcon,
        name: 'PercentageAreaSpline',
        publishDate: new Date('2025-02-25'),
      },
    ],
  },
  {
    category: 'Bubble',
    chartWidgets: [
      {
        type: ChartType.CloudBubble,
        icon: CloudBubbleChartIcon,
        name: 'CloudBubble',
        publishDate: new Date('2025-02-13'),
      },
    ],
  },
  {
    category: 'Stat',
    chartWidgets: [
      {
        type: ChartType.DonutStat,
        icon: DonutStatChartIcon,
        name: 'Donut Stat',
      },
      {
        type: ChartType.DonutStatNoLabel,
        icon: DonutChartIcon,
        name: 'Donut',
        publishDate: new Date('2025-03-07'),
      },
      {
        type: ChartType.HalfDonutStat,
        icon: HalfDonutStatChartIcon,
        name: 'Half-Donut Stat',
      },
      {
        type: ChartType.HalfDonutStatNoLabel,
        icon: HalfDonutChartIcon,
        name: 'Half-Donut',
        publishDate: new Date('2025-03-07'),
      },
      {
        type: ChartType.ProgressBarStat,
        icon: ProgressBarStatChartIcon,
        name: 'Progress Bar Stat',
      },
      {
        type: ChartType.ProgressBarStatNoLabel,
        icon: ProgressBarChartIcon,
        name: 'Progress Bar',
        publishDate: new Date('2025-03-07'),
      },
      {
        type: ChartType.IconStat,
        icon: IconStatChartIcon,
        name: 'Icon Stat',
      },
      {
        type: ChartType.IconStatNoLabel,
        icon: IconChartIcon,
        name: 'Icon',
        publishDate: new Date('2025-03-07'),
      },
    ],
  },
  {
    category: 'Scatter',
    chartWidgets: [
      {
        type: ChartType.ScatterPlot,
        icon: ScatterPlotChartIcon,
        name: 'Scatter Plot',
        publishDate: new Date('2025-02-18'),
      },
      {
        type: ChartType.ScatterBubble,
        icon: ScatterBubbleChartIcon,
        name: 'Scatter Bubble',
        permission: UserTypes.Premium,
      },
    ],
  },
  {
    category: 'Hierarchical',
    chartWidgets: [
      {
        type: ChartType.Pyramid,
        icon: PyramidChartIcon,
        name: 'Pyramid',
        publishDate: new Date('2025-01-29'),
      },
      {
        type: ChartType.Funnel,
        icon: FunnelChartIcon,
        name: 'Funnel',
      },
    ],
  },
  {
    category: 'Other',
    chartWidgets: [
      {
        type: ChartType.TreeMap,
        icon: TreeMapChartIcon,
        name: 'Tree map',
        publishDate: new Date('2025-03-12'),
      },
      {
        type: ChartType.WordCloud,
        icon: WordCloudChartIcon,
        name: 'Word Cloud',
        permission: UserTypes.Premium,
      },
    ],
  },
];

const IS_CHART_NEW_IN_DAYS = 30;

export { CHART_MENU_DATA, CHART_TYPE_TO_DEFAULT_DATA_MAP, IS_CHART_NEW_IN_DAYS };
